import { getThunkAndSlice } from "@src/store/getThunkAndSlice";

const initialState: Array<string> = [];

interface ArtistsResponse {
	artists: Array<string>;
}

export const { thunk: fetchArtists, slice: eventArtistsSlice } = getThunkAndSlice<
	Record<string, never>,
	ArtistsResponse,
	Array<string>
>({
	initialState,
	path: "/api/events/filter/artists",
	onAfterRequest: async (data: ArtistsResponse | Array<string>) => {
		if (Array.isArray(data)) return data;
		return data.artists ?? [];
	},
});

export default eventArtistsSlice.reducer;
